import { Whatsapp } from '@styled-icons/fa-brands/Whatsapp';
import { PlusCircleOutline } from '@styled-icons/evaicons-outline/PlusCircleOutline';
import { MinusCircleOutline } from '@styled-icons/evaicons-outline/MinusCircleOutline';
import { DragIndicator } from '@styled-icons/material/DragIndicator';
import { ChevronRight } from '@styled-icons/boxicons-regular/ChevronRight';
import { UserCircle } from '@styled-icons/boxicons-solid/UserCircle';
import { HelpCircle } from '@styled-icons/boxicons-solid/HelpCircle';
import { Construction } from '@styled-icons/material/Construction';
import { Menu } from '@styled-icons/material/Menu';
import { Search } from '@styled-icons/material/Search';
import { Create } from '@styled-icons/material/Create';
import { ImageAdd } from '@styled-icons/boxicons-regular/ImageAdd';
import { Image } from '@styled-icons/boxicons-regular/Image';
import { Download } from '@styled-icons/evaicons-solid/Download';
import { Trash } from '@styled-icons/boxicons-regular/Trash';
import { DocumentAdd } from '@styled-icons/typicons/DocumentAdd';
import { Check } from '@styled-icons/boxicons-regular/Check';
import { Report } from '@styled-icons/boxicons-solid/Report';
import { ReadMore } from '@styled-icons/material/ReadMore';
import { ContentCopy } from '@styled-icons/material/ContentCopy';
import { Warehouse } from '@styled-icons/fa-solid/Warehouse';
import { ExternalLink } from '@styled-icons/evil/ExternalLink';
import { FileCsv } from '@styled-icons/fa-solid/FileCsv';
import { Printer } from '@styled-icons/boxicons-regular/Printer';
import { Images } from '@styled-icons/ionicons-solid/Images';
import { ErrorWarning } from '@styled-icons/remix-line/ErrorWarning';
import { Error } from '@styled-icons/boxicons-regular/Error';
import { NotificationsCircle } from '@styled-icons/ionicons-solid/NotificationsCircle';
import { Eye } from '@styled-icons/ionicons-outline/Eye';
import { EyeOff } from '@styled-icons/ionicons-outline/EyeOff';
import { EyePlus } from '@styled-icons/icomoon/EyePlus';
import { KeyOff } from '@styled-icons/material/KeyOff';

export { FileExcel as ExcelIcon } from '@styled-icons/fa-solid/FileExcel';

// Search for icons at https://styled-icons.js.org/

export const WhatsappIcon = Whatsapp;
export const PlusIcon = PlusCircleOutline;
export const MinusIcon = MinusCircleOutline;
export const DragHandleIcon = DragIndicator;
export const ChevronIcon = ChevronRight;
export const UserIcon = UserCircle;
export const HelpIcon = HelpCircle;
export const BellIcon = NotificationsCircle;
export const EyeIcon = Eye;
export const EyeOffIcon = EyeOff;
export const EyePlusIcon = EyePlus;
export const BuildIcon = Construction;
export const MenuIcon = Menu;
export const SearchIcon = Search;
export const EditIcon = Create;
export const ViewIcon = ReadMore;
export const ImageAddIcon = ImageAdd;
export const ImageIcon = Image;
export const DownloadIcon = Download;
export const TrashIcon = Trash;
export const DocumentAddIcon = DocumentAdd;
export const CheckIcon = Check;
export const ReportIcon = Report;
export const CopyIcon = ContentCopy;
export const WarehouseIcon = Warehouse;
export const LinkIcon = ExternalLink;
export const CsvIcon = FileCsv;
export const PrinterIcon = Printer;
export const ImagesIcon = Images;
export const ForbiddenIcon = ErrorWarning;
export const WarningIcon = Error;
export const  KeyOffIcon = KeyOff;